import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const pageContext = globalContext.require('PageContext');
const permissions = pageContext && pageContext.Permissions;
const isHotelCenterDeprecation = permissions && permissions.dynamic.HotelCenterDeprecation;

/* global Map */
export function getToolbarConfig({
  i18n,
  lazyInject,
}) {
  const toolbarSelectedConfig = _.chain([
    ['dropdown-extension-edit', {
      type: 'dropdown',
      id: 'dropdown-extension-edit',
      iconLeftGlyphName: 'ba-Edit',
      button: {
        text: i18n.getString(_TL_('Edit')),
        classes: ['btn', 'btn-secondary'],
        attributes: { tabindex: '0' },
        disabled: isHotelCenterDeprecation,
      },
      menu: {
        items: [
          {
            id: 'delete-association',
            iconLeftGlyphName: 'ba-Delete',
            text: i18n.getString(_TL_('Delete association')),
            onClick: () => {
              const gridView = lazyInject().backboneGridView;
              gridView.deleteAssociation();
            },
          }, {
            type: 'dropdown-divider',
          }, {
            id: 'edit-an-extension',
            iconLeftGlyphName: 'ba-Edit',
            text: i18n.getString(_TL_('Edit an extension')),
            onClick: () => {
              const gridView = lazyInject().backboneGridView;
              gridView.editExtension();
            },
          },
        ],
      },
    }],
    ['expander', {
      type: 'expander',
    }],
    ['button-clear-selection', {
      id: 'button-clear-selection',
      type: 'button-clear-selection',
    }],
  ])
    .compact()
    .reduce(
      (map, [key, value]) => {
        map.set(key, value);
        return map;
      },
      new Map()
    )
    .value();

  const toolbarUnselectedConfig = _.chain([
    ['create-adextension-button', {
      id: 'create-adextension-button',
      type: 'button',
      text: i18n.getString(_TL_('Create ad extension')),
      iconLeftGlyphName: 'ba-Add',
      classes: ['btn', 'btn-primary'],
      disabled: isHotelCenterDeprecation,
      onClick: () => {
        const gridView = lazyInject().backboneGridView;
        gridView.createAssociations();
      },
    }],
  ])
    .compact()
    .reduce(
      (map, [key, value]) => {
        map.set(key, value);
        return map;
      },
      new Map()
    )
    .value();

  return {
    toolbarSelectedConfig,
    toolbarUnselectedConfig,
  };
}
